import './ConnectionDialog.css';
import React, { useRef, useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Connections from '../../../libraries/Connections';

import {
    GetAuthUrl,
    GetToken,
    SaveToken,
} from '../../../services/Connection.service';

import GmailIcon from '../../../libraries/Icons/gmail.png';
import GoogleDrive from '../../../libraries/Icons/GoogleDrive.png';
import GoogleCalendar from '../../../libraries/Icons/GoogleCalendar.png';
import GoogleDocs from "../../../libraries/Icons/GoogleDocs.png";
import GoogleSpreadsheets from '../../../libraries/Icons/GoogleSpreadsheets.png';
import AwsS3 from '../../../libraries/Icons/AwsS3.png';
import Ftp from '../../../libraries/Icons/Ftp.png';
import Filemaker from '../../../libraries/Icons/Filemaker.png';

function ConnectionDialog(props) {
    const { translate, SnackbarAlert, open, handleClose, connectionInfor={} } = props;

    let windowObjectReference = null;
    let previousUrl = null;  

    const [mode, setMode] = React.useState(0);
    const [searchValue, setSearchValue] = React.useState();

    const typingTimeoutRef = useRef(null);

    const nameRef = useRef();

    const awsS3Ref = useRef({
        accessKeyId: undefined,
        secretAccessKey: undefined,
    }) 

    const ftpRef = useRef({
        host: undefined,
        user: undefined,
        password: undefined,
        secure: 'false'
    }) 

    const filemakerRef = useRef({
        host: undefined,
        version: 'v1',
        username: undefined,
        password: undefined,
        database: undefined,
    })

    const CardImage = ({name, size}) => (
        <>
        {
            name === 'Gmail' ? <img alt="" src={GmailIcon} height={size} /> :
            name === 'Google Calendar' ? <img alt="" src={GoogleCalendar} height={size} /> :
            name === 'Google Drive' ? <img alt="" src={GoogleDrive} height={size} /> :
            name === 'Google Docs' ? <img alt="" src={GoogleDocs} height={size} /> :
            name === 'Google Spreadsheets' ? <img alt="" src={GoogleSpreadsheets} height={size} /> :
            name === 'AWS S3' ? <img alt="" src={AwsS3} height={size} /> :
            name === 'FTP' ? <img alt="" src={Ftp} height={size} /> :
            name === 'Filemaker' ? <img alt="" src={Filemaker} height={size} /> :
            ""
        }
        </>
    )

    const handleClickAgree = () => {
        let result;
        switch (nameRef.current) {
            case "AWS S3":
                result = handleValueOfObject(awsS3Ref.current);
                break;
            case "FTP":
                result = handleValueOfObject(ftpRef.current);
                break;
            case "Filemaker":
                result = handleValueOfObject(filemakerRef.current);
                break;
        }
        if(result.flag) {
            handleClose();
            SaveToken(result.data, nameRef.current, connectionInfor.providerID)
            .then(res => {
                // console.log(res)
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    }
                });
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            })
        } else {
            props.dispatch({ 
                type: 'UPDATE_SNACKBARALERT', 
                SnackbarAlert: {
                    open: true,
                    severity: "error",
                    message: translate('msg_pleaseenterthedataintherequiredfield'),
                    handleClose: () => handleCloseSnackbarAlert()
                } 
            });
        }
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleValueOfObject = (data) => {
        let flag = true;
        Object.keys(data).map(key => {
          if (!data[key]) {
            flag = false;
            data[key] = "";
          }
        })
        return { flag, data };
    }    

    const searchInputOnChange = (event) => {
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(() => {
            setSearchValue(event.target.value)
        }, 300)
    }
    
    const handleSelectConnection = async (name, providerID) => {
        switch (name) {
            case "Gmail":
            case "Google Drive":
            case "Google Calendar":
            case "Google Docs":
            case "Google Spreadsheets":
                localStorage.setItem('_connectionInfor', JSON.stringify({ name, providerID }));
                handleClose();
                GetAuthUrl(name)
                .then((res) => {
                    // console.log(res.data.authUrl);
                    openSignInWindow(res.data.authUrl, name)
                })
                .catch((err) =>  {
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: err?.response?.data?.status,
                            message: translate(`${err?.response?.data?.msg}`),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                })
                break;
            case "AWS S3":
                nameRef.current = name;
                await GetToken(providerID)
                .then((res) => {
                    // console.log(res);
                    if(res.data) awsS3Ref.current = res.data;
                });
                setMode(2);
                break;
            case "FTP":
                nameRef.current = name;
                await GetToken(providerID)
                .then((res) => {
                    // console.log(res);
                    if(res.data) ftpRef.current = res.data;
                });
                setMode(2);
                break;
            case "Filemaker":
                nameRef.current = name;
                await GetToken(providerID)
                .then((res) => {
                    if(res.data) filemakerRef.current = res.data;
                });
                setMode(2);
                break;
        }
    }

    const openSignInWindow = (url, name) => {
        const strWindowFeatures =
        `toolbar=no, menubar=no, width=600, height=700, left=${(window.screenLeft + (window.innerWidth - 600) / 2)}, top=${(window.screenTop + (window.innerHeight - 700) / 2)}`;
        if (windowObjectReference === null || windowObjectReference.closed) {
          windowObjectReference = window.open(url, name, strWindowFeatures);
        } else if (previousUrl !== url) {
          windowObjectReference = window.open(url, name, strWindowFeatures);
          windowObjectReference.focus();
        } else {
          windowObjectReference.focus();
        }
        previousUrl = url;
    };

    useEffect(() => {
        let { name, providerID } = connectionInfor;
        if (open && (!name || !providerID)) setMode(1);
        else handleSelectConnection(name, providerID);
    }, [open, connectionInfor])

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={handleClose}
        >
            {mode === 1 && 
            <>
                <DialogTitle>
                    {translate('connectionlist')}
                    <IconButton className="connection-close" aria-label="search" onClick={handleClose} >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box className="connection-search">
                        <IconButton className="iconButton" aria-label="search">
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            placeholder={translate('search')}
                            onChange={searchInputOnChange}
                        />
                    </Box>
                    <Box className="connection-dialog">
                        {Connections?.filter((conn) => !searchValue || conn.name?.toLowerCase().includes(searchValue?.toLowerCase())).map((card) => (
                            <Card key={card.name} className='card' onClick={() => handleSelectConnection(card.name, undefined)}>
                                <CardContent>
                                    <Box display="flex" gap={1}>
                                        <Box>
                                            <CardImage name={card.name} size={48} />
                                        </Box>
                                        <Box sx={{ padding: "0px 8px" }}>
                                            <Typography variant="h6" component="div" sx={{ color: "rgba(32, 33, 36)" }}>
                                            {card.name}
                                            </Typography>
                                            <Typography variant="body2" component="div" sx={{ color: "rgba(0, 0, 0, 0.6)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                            {translate(`${card.subtitle}`)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))} 
                    </Box>
                </DialogContent>
            </>}
            {mode === 2 && <>
                <DialogTitle>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CardImage name={nameRef.current} size={40} />
                        <Box sx={{ ml: 2 }}>{nameRef.current}</Box>
                    </Box>
                    <IconButton className="connection-close" aria-label="search" onClick={handleClose} >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ textAlign: "left", p: "5px" }}>
                    {translate('msg_pleaseenterthedataintherequiredfield')}
                    </Box>
                    {nameRef.current === "AWS S3" && 
                    <Box className='connection-dialog-box'>
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('accesskeyid')}
                            defaultValue={awsS3Ref.current.accessKeyId} 
                            onChange={(e) => awsS3Ref.current.accessKeyId = e.target.value}
                            placeholder=""
                            error={( awsS3Ref.current.accessKeyId === "")}
                        />
                        <TextField 
                            type="password"
                            required 
                            fullWidth 
                            label={translate('secretaccesskey')}
                            defaultValue={awsS3Ref.current.secretAccessKey} 
                            onChange={(e) => awsS3Ref.current.secretAccessKey = e.target.value}
                            placeholder=""
                            error={( awsS3Ref.current.secretAccessKey === "")}
                        />
                    </Box>}
                    {nameRef.current === "FTP" && 
                    <Box className='connection-dialog-box'>
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('host')}
                            defaultValue={ftpRef.current.host} 
                            onChange={(e) => ftpRef.current.host = e.target.value}
                            placeholder=""
                            error={( ftpRef.current.host === "")}
                        />
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('user')}
                            defaultValue={ftpRef.current.user} 
                            onChange={(e) => ftpRef.current.user = e.target.value}
                            placeholder=""
                            error={( ftpRef.current.user === "")}
                        />
                        <TextField 
                            type="password"
                            required 
                            fullWidth 
                            label={translate('password')}
                            defaultValue={ftpRef.current.password} 
                            onChange={(e) => ftpRef.current.password = e.target.value}
                            placeholder=""
                            error={( ftpRef.current.password === "")}
                        />
                        <TextField
                            select
                            label={translate('secure')}
                            defaultValue={ftpRef.current.secure}
                            onChange={(e) => ftpRef.current.secure = e.target.value}
                            sx={{ textAlign: 'left' }}
                            >
                            <MenuItem value={'true'}>{ translate('yes') }</MenuItem>
                            <MenuItem value={'false'}>{ translate('no') }</MenuItem>
                        </TextField>
                    </Box>}
                    {nameRef.current === "Filemaker" && 
                    <Box className='connection-dialog-box'>
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('host')} 
                            defaultValue={filemakerRef.current.host} 
                            onChange={(e) => filemakerRef.current.host = e.target.value}
                            placeholder="192.168.0.1"
                            error={( filemakerRef.current.host === "")}
                        />
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('version')}
                            defaultValue={filemakerRef.current.version} 
                            onChange={(e) => filemakerRef.current.version = e.target.value}
                            placeholder="v1, v2, vLatest"
                            error={( filemakerRef.current.version === "")}
                        />
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('username')} 
                            defaultValue={filemakerRef.current.username} 
                            onChange={(e) => filemakerRef.current.username = e.target.value}
                            placeholder="admin"
                            error={( filemakerRef.current.username === "")}
                        />
                        <TextField 
                            type="password"
                            required 
                            fullWidth 
                            label={translate('password')}
                            defaultValue={filemakerRef.current.password} 
                            onChange={(e) => filemakerRef.current.password = e.target.value}
                            placeholder="********"
                            error={( filemakerRef.current.password === "")}
                        />
                        <TextField 
                            required 
                            fullWidth 
                            label={translate('database')} 
                            defaultValue={filemakerRef.current.database} 
                            onChange={(e) => filemakerRef.current.database = e.target.value}
                            placeholder="demo.fmp12"
                            error={( filemakerRef.current.database === "")}
                        />
                    </Box>}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" size="small" disableElevation color='secondary' onClick={handleClose}>
                        {translate('cancel')}
                    </Button>
                    <Button variant="contained" size="small" disableElevation color="info" onClick={handleClickAgree}>
                        {translate('ok')}
                    </Button>
                </DialogActions>
            </>}
        </Dialog>
    );
}
function mapStateToProps(state) {
    return {
      SnackbarAlert: state.SnackbarAlert,
    }
}
export default connect(mapStateToProps)(withTranslate(ConnectionDialog));